import { render } from "./CheckboxItem.vue?vue&type=template&id=28a4f834&scoped=true"
import script from "./CheckboxItem.vue?vue&type=script&lang=ts"
export * from "./CheckboxItem.vue?vue&type=script&lang=ts"

import "./CheckboxItem.vue?vue&type=style&index=0&id=28a4f834&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-28a4f834"

export default script